__turbopack_context__.v({
  "childrenContainer": "KX_nLa_childrenContainer",
  "root": "KX_nLa_root",
  "stickyContainer": "KX_nLa_stickyContainer",
});
